import { Link } from "react-router-dom";
import styled from "styled-components";

const CustomLink = styled(Link)`
  text-decoration: none;
  color: #176cdb;
  font-weight: 500;
  :hover {
    text-decoration: underline;
  }
`;

export default CustomLink;